import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import { Grid } from "semantic-ui-react";
import SupportingDocForm from '@EUForms/supportingDocForm'
import { useDispatch, useSelector } from 'react-redux'
import { selectSupportingDocumentList,selectMeasurementUnitList } from '@EUForms/selectors'
import CopyRepElement from '@commonComponents/copyRepElement'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { updateValidationErrors } from '../../reducer/validationSlice'
import validate from 'validate.js'
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { useTranslation } from '@hooks/useTranslation';



const SupportingDocDetail = ({ dataSource,fieldPattern,createRepElemMsgStructure,invoiceIndex,itemIndex,onChange, onBlur, ...rest }) => {

  const dropdownList = useSelector(selectSupportingDocumentList)
  const mUnitList = useSelector(selectMeasurementUnitList)
  const translate = useTranslation()
  const {isDisabled} = useCurrentShipmentType()


  const dispatch = useDispatch()
  const { supportingDocumentsList } = fieldPattern()?.itemsTab


  const supportingDocValidarion = (suppDocIdx,name,value) =>{

    const key = `invoice${invoiceIndex+1}_lineItem${itemIndex+1}_SUPPORT_DOCUMENT${suppDocIdx+1}_${name}` 
    let repElemErr = validate({[name]:value},
      {[name]:supportingDocumentsList[name]}
    ) || {}

    repElemErr = createRepElemMsgStructure(repElemErr, translate("SUPPORT_DOCUMENT"), invoiceIndex, itemIndex, suppDocIdx,translate)

    dispatch(updateValidationErrors({
      tabName: 'itemsTab',
      errors: {...repElemErr},
      errorKeys: [key]
  }))
  }

  const renderItem = useCallback(
    ({ id, ...restItem }, suppDocIdx) => {
      const onBlurHandler = (tableName, params, name) => {
        const extraFields = {}
        if(name==='quantity' && !restItem?.quantity.trim()){
          // onDropDownChange({},{value:' ', name:'unitOfMeasurement'})
          extraFields['unitOfMeasurement'] = ' '
          onChange(id, tableName, extraFields)
        }
        onBlur(tableName, {...params, ...extraFields})
      }
      const renderAtLast = ({ id:id1, unitOfMeasurement, onDropDownChange }) => {
        // if(restItem?.quantity === " "){
        //   onDropDownChange({},{value:' ', name:'unitOfMeasurement'})
        // }
        return (
          <>
            <Grid.Column>
              <DropDown
                id={`mUnit-${id}`}
                type='text'
                label='M UNIT'
                value={unitOfMeasurement}
                text={unitOfMeasurement}
                data={mUnitList}
                name='unitOfMeasurement'
                onChange={onDropDownChange}
                isDisabled={!restItem?.quantity?.trim() ? true : null}
              />
            </Grid.Column>
          </>
        )
      }

      return (
        <SupportingDocForm
          key={id}
          dataSource={{ id, ...restItem }}
          copyDocument={(translate) => (
            <CopyRepElement
              translate={translate}
              title='SUPPORTING_DOCUMENT'
              request={{ id, ...restItem, infoType: 'EU_SUPPORTING_DOCUMENT' }}
              callback={rest?.copyData}
              isFormDisabled={isDisabled}
              tableName={rest?.tableName}
            />
          )}
          docCodeList={dropdownList}
          suppDocIdx={suppDocIdx}
          supportingDocValidarion={supportingDocValidarion}
          renderAtLast={renderAtLast}
          onChange={onChange}
          onBlur={onBlurHandler}
          {...rest}
        />
      )
    },
    [dropdownList]
  )

  return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(SupportingDocDetail)
